import React from 'react'
import './backDrop.scss'

const backDrop =(props)=> {
    return (
        <div className="backdrop" onClick = {props.toggleSidebar}/>
    )
}
export default  backDrop